// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rSdR","toggle":"styles_toggle__2wiJP","preview":"styles_preview__Pp2T0"};